<template>
  <el-dialog
    :title="`Preview - ${title}`"
    visible
    width="70%"
    :close-on-click-modal="false"
    @close="$emit('update:isShow', false)"
  >
    <el-card
      :body-style="{ width: '100%', height: '500px', padding: '0px' }"
      shadow="never"
    >
      <c-grid
        v-if="headers && previewData"
        :data="previewData"
      >
        <c-grid-column
          v-for="(header, index) in headers"
          :key="index"
          :field="header"
        >
          {{ header }}
        </c-grid-column>
      </c-grid>
      <div
        v-else
        v-loading="true"
        style="height: 100px;"
      />
    </el-card>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        size="small"
        @click.native="$emit('update:isShow', false)"
      >Close</el-button>
      <el-button
        type="primary"
        :loading="!headers || !previewData"
        size="small"
        @click.native="download"
      >
        Download
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import Request from '@/plugins/sdk/Request'
import { saveAs } from 'file-saver'

export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: 'Report'
    },
    configuration: {
      type: Object,
      required: true
    },
    isDirectDownload: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      report: null,
      fileName: '',
      headers: null,
      previewData: null
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    download () {
      saveAs(this.report, this.filename)
    },
    async fetchData () {
      const response = await fetch(await Object.assign(new Request(), {
        _pathname: `/reports/${this.configuration.report}`,
        filters: this.configuration.params
      }).build())

      if (response.ok) {
        this.report = await response.blob()
        this.filename = response.headers.get('content-disposition').match(/"((?:\\.|[^"\\])*)"/).pop()

        if (this.isDirectDownload) {
          this.download()
          this.$emit('update:isShow', false)
        } else {
          this.$papa.parse(this.report, {
            header: true,
            preview: 100,
            complete: ({ data }) => {
              this.previewData = data
              this.headers = Object.keys(data[0])
            }
          })
        }
      } else {
        this.$message({
          showClose: true,
          message: 'Error on downloading report',
          type: 'error'
        })
      }
    }
  }
}
</script>
